import { useState, useEffect } from 'react';
import { getInstructorLists } from '../api/instructor';

const useFetchInstructorList = (storeId, isWork = true) => {
  const [instructorListOption, setInstructorListOption] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchInstructorList = async () => {
      try {
        const instructorList = await getInstructorLists({ storeId, isWork });
        const transformedOptions = instructorList.map(instructor => ({
          value: instructor.id,
          label: instructor.status === 'WORK'
            ? instructor.user.name
            : `${instructor.user.name} (종료)`,
        }));
        setInstructorListOption(transformedOptions);
      } catch (err) {
        setError(err);
      }
    };
    fetchInstructorList();
  }, [storeId, isWork]);

  return { instructorListOption, error };
};

export default useFetchInstructorList;
